import {
  AllocationRowState,
  CheckinRowState,
  VendorReceivingStep,
} from 'src/components/VendorReceiving/types';

export type VendorCheckinRows = Record<string, CheckinRowState>;
export type VendorAllocationRows = Record<string, AllocationRowState>;

export type VendorReceivingState = {
  currentStep: VendorReceivingStep;
  selectedVendorId: string | null;
  selectedVendorName: string | null;
  checkinRowsByVendorId: Record<string, VendorCheckinRows>;
  allocationRowsByVendorId: Record<string, VendorAllocationRows>;
  // Persisted so the editing-window timestamp survives a reload between the
  // POCheckIn save and the CustomerAllocation save. ISO8601DateTime string.
  checkinWindowByVendorId: Record<string, string>;
  // Set to true only when the user dispatches a row change. Server-seeded
  // rows don't flip this — that's how we tell "user edited" apart from
  // "we just hydrated from server" for the discard-confirm modal.
  hasEditsByVendorId: Record<string, boolean>;
  // Server-forced view-mode override per vendor. Flipped to true when a
  // mutation returns a "Receiving window has closed" userError. Lives in
  // Redux (not local component state) so POCheckIn flipping it is visible
  // to CustomerAllocation without an extra round-trip. Auto-cleared by
  // setCheckinWindow when the new timestamp is in the future (admin
  // re-extended the cutoff).
  forceClosedByVendorId: Record<string, boolean>;
};

export const initialState: VendorReceivingState = {
  currentStep: VendorReceivingStep.VendorList,
  selectedVendorId: null,
  selectedVendorName: null,
  checkinRowsByVendorId: {},
  allocationRowsByVendorId: {},
  checkinWindowByVendorId: {},
  hasEditsByVendorId: {},
  forceClosedByVendorId: {},
};
